import React from 'react';
import styled from 'styled-components';
import { Text } from '@make-software/tg-mini-app-ui';

interface SectionTitleProps {
  children: React.ReactNode;
}

const Wrapper = styled.div({
  margin: '16px 0'
});

export const SectionTitle: React.FC<SectionTitleProps> = ({ children }) => (
  <Wrapper>
    <Text weight={1} size="xl" color="white" as="div">
      {children}
    </Text>
  </Wrapper>
);
